module.exports = __webpack_public_path__ + "static/media/analytics.08ac47ab.svg";